module.exports = __webpack_public_path__ + "static/street-saopaolo-bf0ffd76994cd5170f63c578eab597de.png";